import styled, { css } from "styled-components";

const fontStyles = css`
  font-family: "Lato";
  line-height: 1;
  font-size: 1rem;
`;

export const HeaderWrapper = styled.div`
  background: #15aee5;
  display: flex;
  justify-content: space-between;
  padding: 1.375rem;
`;

export const Title = styled.h2`
  font-size: 1.125rem;
  color: white;
  font-family: "Lato";
  line-height: 1;
  margin: 0;
  text-transform: initial;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 1.375rem;
  padding-right: 40px;
`;

export const FormBody = styled.div`
  max-height: 60vh;
  padding: 15px 1.375rem 0px;
  overflow-y: auto;
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: ${(props) => props.align ?? "center"};
  > div {
    margin-right: 1rem;
  }
`;

export const SectionContainer = styled.section`
  width: 100%;
`;

export const GridRow = styled.div`
  display: grid;
  grid-template-columns: ${(props) => props.column ?? "1fr"};
  gap: ${(props) => props.gridGap ?? "1.25rem;"};
  margin-bottom: ${(props) => props.marginBottom ?? "10px"};
  font-weight: normal;
  margin-top: ${(props) => props.marginTop ?? "10px"};
  border-bottom: ${(props) =>
    props.borderBottom ?? "0px solid rgba(10, 73, 134, 0.3)"};
`;

export const RowHeader = styled.div`
  background-color: #008395;
  justify-content: space-between;
  padding: 0px 0px;
  font-size: 16px;
  font-weight: 700;
  border-radius: 5px 5px 0px 0px;
`;

export const GridItem = styled.div`
  border-right: ${(props) =>
    props.borderRight ?? "2px solid rgba(10, 73, 134, 0.3)"};
  border-left: ${(props) =>
    props.borderLeft ?? "0px solid rgba(10, 73, 134, 0.3)"};
  line-height: 2rem;
  text-align: ${(props) => props.textAlign ?? "center"};
  color: ${(props) => props.color ?? "#474747"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  background-color: ${(props) => props.backgroundColor ?? "#fff"};
  padding: ${(props) => props.padding ?? "10px"};
  font-size: ${(props) => props.fontSize ?? "16px"};
  border-top-left-radius: ${(props) => props.leftRadius ?? "0px"};
  border-top-right-radius: ${(props) => props.rightRadius ?? "0px"};
  align-content: ${(props) => props.alignContent ?? "normal"};
`;

export const GridSubItem = styled.div`
  color: ${(props) => props.color ?? "#0a4986"};
  font-style: ${(props) => props.fontStyle ?? "normal"};
  font-weight: ${(props) => props.fontWeight ?? "400"};
  font-size: ${(props) => props.fontSize ?? "14px"};
  text-align: ${(props) => props.textAlign ?? "left"};
  align-content: ${(props) => props.alignContent ?? "normal"};
  padding: ${(props) => props.padding ?? "0px"};
  border-right: ${(props) =>
    props.borderRight ?? "0px solid rgba(10, 73, 134, 0.3)"};
`;

export const PlanningOuter = styled.section`
  display: flex;
  flex-direction: column;
  width: 100%;
  box-shadow: ${(props) =>
    props.boxShadow ?? "2px 2px 4px 1px rgba(0, 76, 127, 0.25)"};
  background-color: white;
  border-radius: 4px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${(props) => props.marginBottom ?? "0px"};
`;

export const Labeltext = styled.label`
  font-size: ${(props) => props.fontSize ?? "1.5rem;"};
  color: ${(props) => props.color ?? "#0a4986"};
  font-family: "Lato";
  line-height: 1;
  margin: ${(props) => props.margin ?? "0"};
  text-transform: initial;
  font-weight: ${(props) => props.fontWeight ?? "700"};
`;

export const InvoiceOuter = styled.div`
  justify-self: end;
`;

export const CounterNotification = styled.span`
  position: absolute;
  margin-left: -17px;
  margin-top: -19px;
  border-radius: 50%;
  background-color: #1bace4;
  color: white;
  font-size: 12px;
  width: 30px;
  height: 30px;
  padding: 1px;
`;
